module.exports = __webpack_public_path__ + "static/img/14.892d01c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/14.png
// module id = k81H
// module chunks = 0